module.exports = __webpack_public_path__ + "assets/img/Logitech-G-1-Social-Static-Ad.0eb7be58.png";